import React from "react";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, Col, InputGroup } from "react-bootstrap";
import { SeasonsUserTable } from "../allTables/allTable";
import { useEffect } from "react";
import { useState } from "react";
import * as XLSX from "xlsx";
import * as yup from "yup";
import { AddSeasons, DeleteSeasonsModule } from "../modals/allModal";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import SeasonsService from "../../services/season.service";
import Searchable from "react-searchable-dropdown";
import { useLocation } from "react-router-dom";

const schema = yup.object().shape({
  data: yup.mixed().required("Please Upload Your Data"),
  season: yup.string().required("Season is Required"),
});

export function Seasons() {
  const location = useLocation();
  const selectedType = location.search.split("=")[1];
  const [data, setData] = useState("");
  const [seasonsListData, setSeasonsListData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loader, setLoader] = useState(false);
  const [totalRows, setTotalRows] = useState("");
  const handleDialogClose = () => setModalShow(false);
  const handleDeleteClose = () => setDeleteModal(false);
  const [showFilterValue, setShowFilterValue] = useState("");
  const [search, setSearch] = useState("");

  const getAllSeasonsList = async () => {
    setIsLoading(true);
    try {
      const response = await SeasonsService.getAllSeasonsList(
        pageNumber,
        dataPerPage,
        selectedType.toUpperCase()
      );
      setSeasonsListData(response.data.data);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleData = (e) => {
    setSearch(e.target.value);
  };

  const getAllSeasons = async () => {
    const response = await SeasonsService.getAllSeasons(
      pageNumber,
      dataPerPage,
      showFilterValue,
      search,
      selectedType.toUpperCase()
    );
    setData(response.data.data);
    setTotalRows(response.data.total);
  };

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    await getAllSeasons();
    setIsLoading(false);
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllSeasons();
    getAllSeasonsList();
  }, [pageNumber, dataPerPage, search, showFilterValue, selectedType]);

  const handleOpen = async () => {
    setModalShow(true);
    formik.setFieldValue("data", "");
  };

  const initialValue = {
    data: [],
    season: "",
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (!file || !file.name.endsWith(".xlsx")) {
      enqueueSnackbar(
        "Invalid File Type! Only Excel files (XLSX) are allowed.",
        {
          variant: "error",
        }
      );
      return;
    }
    const reader = new FileReader();
    reader.onload = async function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      formik.setFieldValue("data", sheetData);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleStatusFilter = (res) => {
    setShowFilterValue(res);
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      const data = {
        ...values,
        type: selectedType.toUpperCase(),
      };
      await SeasonsService.CreateSeasons(data);
      setLoader(false);
      setModalShow(false);
      getAllSeasons();
      action.resetForm();
      formik.resetForm();
    } catch (error) {
      enqueueSnackbar(
        error.response.data.message ===
          "Duplicate Seasons data. Upload not allowed."
          ? "Same Data Not Allowed"
          : "Something went Wrong",
        {
          variant: "error",
        }
      );
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });
  const handleDelete = () => {
    setDeleteModal(true);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Season's Users
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-solid fa-cloud fa-cloudflare icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRows}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col
          sm={12}
          md={6}
          lg={6}
          xl={6}
          className="d-flex ms-auto mt-auto justify-content-end m-0">
          <div className="me-3 mb-3 d-flex justify-content-between">
            <InputGroup style={{ width: "fit-content" }}>
              <Searchable
                className="form-control select2 ml-0"
                value={showFilterValue}
                placeholder="Filter by Season"
                notFoundText="No result found"
                noInput
                selectedVal={showFilterValue}
                options={[
                  { label: "All", value: "" },
                  ...seasonsListData?.map((item) => ({
                    label: item?.name,
                    value: item?._id,
                  })),
                ]}
                onSelect={(e) => handleStatusFilter(e)}
                listMaxHeight={150}
              />
            </InputGroup>
            <Button
              className="text-white"
              style={{ marginBottom: "5px", marginLeft: "15px" }}
              onClick={() => handleOpen("")}>
              <i className="fas fa-plus"></i> &nbsp; Add Seasons Data
            </Button>
            <Button
              className="text-white"
              variant="danger"
              style={{ marginBottom: "5px", marginLeft: "15px" }}
              onClick={() => handleDelete("")}>
              <i className="fas fa-trash"></i> &nbsp; Delete All Seasons Data
            </Button>
          </div>
          <div
            className="custom-card text-end pointer"
            style={{ marginRight: "18px" }}>
            {modalShow && (
              <AddSeasons
                show={modalShow}
                seasonsListData={seasonsListData}
                onHide={handleDialogClose}
                formik={formik}
                loader={loader}
                handleFileUpload={handleFileUpload}
              />
            )}
            {deleteModal && (
              <DeleteSeasonsModule
                show={deleteModal}
                seasonsListData={seasonsListData}
                onHide={handleDeleteClose}
                formik={formik}
                getAllSeasons={getAllSeasons}
              />
            )}
          </div>
        </Col>
      </div>

      <SeasonsUserTable
        data={data}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        dataPerPage={dataPerPage}
        isLoading={isLoading}
        setDataPerPage={setDataPerPage}
        getAllSeasons={getAllSeasons}
        handleData={handleData}
      />
    </>
  );
}
